import { isSameDay, getDayLabel, isWithinTimeSpan, isDateBefore, toLocalDate } from "../../../../../utils/v3/utils/datetime.js";
import { Variant } from "../../../../NoTimeSlots/v3/components/NoTimeSlots/types.js";
const firstAvailableDate = (weeks, availability = {}) => {
  const sortedAvailableDates = Object.entries(availability).map(([dateString, available]) => available ? new Date(dateString) : null).filter((entry) => entry !== null).sort((a, b) => a.getTime() - b.getTime());
  const allWeekDates = [].concat(...weeks);
  return sortedAvailableDates.find((date) => allWeekDates.find((entry) => isSameDay(entry, date)));
};
const getNextAvailableDate = (after, availability = {}) => {
  if (!after) {
    return;
  }
  const normalizedDate = new Date(after);
  normalizedDate.setHours(0, 0, 0, 0);
  const sortedAvailableDates = Object.entries(availability).map(([dateString, available]) => available ? new Date(dateString) : null).filter((entry) => entry !== null).sort((a, b) => a.getTime() - b.getTime());
  return sortedAvailableDates.find((date) => date.getTime() > normalizedDate.getTime());
};
const getLastWeekDay = (weeks) => {
  const [lastWeek = []] = weeks.slice(-1);
  const [lastWeekDay] = lastWeek.slice(-1);
  return lastWeekDay;
};
const OPENING_TIMES_DAY_INDEX = [
  "sunOpenClose",
  "monOpenClose",
  "tueOpenClose",
  "wedOpenClose",
  "thuOpenClose",
  "friOpenClose",
  "satOpenClose"
];
const getSpecifiedOpeningTimes = (weeks, openingTimes) => {
  const timeStringToDate = (date, timeString) => {
    const [hours, minutes] = timeString.split(":");
    const timeStringDate = new Date(date);
    hours && timeStringDate.setHours(parseInt(hours, 10));
    minutes && timeStringDate.setMinutes(parseInt(minutes, 10));
    timeStringDate.setSeconds(0);
    timeStringDate.setMilliseconds(0);
    return timeStringDate;
  };
  const openCloseTimeStringsToDates = (date, pair) => ({
    open: timeStringToDate(date, pair.open),
    close: timeStringToDate(date, pair.close)
  });
  const getFormattedTimePairs = (date, pairs) => pairs ? pairs.filter(
    (pair) => pair.open !== null && pair.close !== null
  ).map((pair) => openCloseTimeStringsToDates(date, pair)) : null;
  return weeks.reduce(
    (acc, week) => week.reduce((acc2, date) => {
      const dateKey = toLocalDate(date);
      const specialRoster = (openingTimes.specialOpenClosingHours ?? []).find(
        ({ dateOpenClosed }) => dateOpenClosed !== null && isSameDay(new Date(dateOpenClosed), date)
      );
      const dayIndex = OPENING_TIMES_DAY_INDEX[date.getDay()];
      const openingTimeForDay = dayIndex && openingTimes?.[dayIndex];
      const regularRoster = dayIndex !== void 0 && openingTimeForDay ? getFormattedTimePairs(date, openingTimeForDay) : null;
      if (specialRoster) {
        if (specialRoster.openClosed === "CLOSED" || !specialRoster.openClosedTime) {
          acc2[dateKey] = null;
          return acc2;
        }
        acc2[dateKey] = getFormattedTimePairs(date, specialRoster.openClosedTime);
        return acc2;
      }
      acc2[dateKey] = regularRoster;
      return acc2;
    }, acc),
    {}
  );
};
const getClosedDates = (weeks, openingTimes) => {
  const specifiedOpeningTimes = getSpecifiedOpeningTimes(weeks, openingTimes);
  return Object.entries(specifiedOpeningTimes).filter(([, value]) => value === null).map(([key]) => new Date(key));
};
const tileNameLabelsByWeeks = (weeks) => {
  const firstWeek = weeks[0];
  return firstWeek?.map((day) => getDayLabel(day, "short"));
};
const formatTileData = (weeks, availability = {}, closedDates = [], minEnabledDate, maxEnabledDate, selectedDate) => {
  const normalizedMinEnabledDate = new Date(minEnabledDate);
  const normalizedMaxEnabledDate = maxEnabledDate ? new Date(maxEnabledDate) : null;
  const normalizedSelectedDate = selectedDate ? new Date(selectedDate) : null;
  normalizedMinEnabledDate.setHours(0, 0, 0, 0);
  normalizedMaxEnabledDate?.setHours(0, 0, 0, 0);
  normalizedSelectedDate?.setHours(0, 0, 0, 0);
  return weeks.map(
    (week) => week.map((date) => {
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0);
      const disabled = maxEnabledDate ? !isWithinTimeSpan(normalizedDate, normalizedMinEnabledDate, maxEnabledDate) : isDateBefore(normalizedDate, normalizedMinEnabledDate);
      const closed = closedDates.some((entry) => isSameDay(entry, normalizedDate));
      const available = !disabled && !closed && (availability[toLocalDate(date)] ?? false);
      const selected = !disabled && normalizedSelectedDate ? isSameDay(normalizedSelectedDate, normalizedDate) : false;
      return {
        date,
        available,
        closed,
        selected,
        disabled
      };
    })
  );
};
const getCalendarTimeSlotsAvailability = (availability = {}, noTimeSlotsVariant) => {
  const calendarHasNoAvailability = !Object.values(availability).some((available) => available);
  const hasNoTimeSlotsAvailableInCalendar = (noTimeSlotsVariant === Variant.date || noTimeSlotsVariant === Variant.week) && calendarHasNoAvailability;
  return hasNoTimeSlotsAvailableInCalendar;
};
export {
  firstAvailableDate,
  formatTileData,
  getCalendarTimeSlotsAvailability,
  getClosedDates,
  getLastWeekDay,
  getNextAvailableDate,
  getSpecifiedOpeningTimes,
  tileNameLabelsByWeeks
};
//# sourceMappingURL=utils.js.map
